/* eslint-disable */
import React, { useState, useEffect, useRef, Fragment } from "react";
import {
    Card,
    Layout,
    Row,
    Col,
    Button,
    Input,
    message,
    Modal,
    Space,
    TimePicker,
    DatePicker,
    Form,
    Table,
    Select, Badge,
    Divider,Upload
} from "antd";
import {
    EditOutlined,
    MoreOutlined,
    ImportOutlined,
    DownloadOutlined,
    PrinterOutlined,
    QrcodeOutlined,
    DeleteOutlined ,
    ExportOutlined ,
    FileExcelOutlined,
    UploadOutlined,
  } from "@ant-design/icons";
import { Redirect } from "react-router-dom";
import Axios from "axios";
import moment from "moment";
import { url } from "../../config/global";
import { BarcodeOutlined } from "@ant-design/icons";
import fileDownload from "js-file-download";

const { Search } = Input;
const { Content } = Layout;
const { RangePicker } = DatePicker;
const layout = {
    labelCol: {
        xs: 24,
        lg: 24,
        md: 24,
    },
    wrapperCol: {
        xs: 24,
        lg: 24,
        md: 24,
    },
};

function MasterStock(props) {
    const [selectedRowKeysData, setSelectedRowKeysData] = useState([]);
    const [selectedRowsData, setSelectedRowsData] = useState([]);
    const [beforePaintList, setbeforePaintList] = useState([]);
    const [page, setPage] = useState(1);
    const [modalImport, setModalImport] = useState(false);
    const [dnExtProcess, setdnExtProcess] = useState([]);
    const [loading, setloading] = useState(false);
    const [loadingPrint, setloadingPrint] = useState(false);
    const [loadingDetail, setLoadingDetail] = useState(false);
    const [selectedItemNumber, setSelectedItemNumber] = useState('');
    const [selectedModel, setSelectedModel] = useState('');
    const [pageSize, setPagesize] = useState(10);
    const [pageSizeDetail, setPagesizeDetail] = useState(10);
    const [date, setDate] = useState([]);
    const [failedData, setFailedData] = useState([]);
    const [stockType, setStockType] = useState(null);
    const [oneTimeGet, setOneTimeGet] = useState(false);
    const [selectProject, setSelectProject] = useState(null);
    const [sort, setSort] = useState({
        sort: "item_number",
        order: "ascend",
    });
   
    const [data, setData] = useState({
        ref_dn: null,
        lot_prod: null,
        dn_outgoing: null,
        item_after: null,
        kanban_no: [],
        scan_outgoing_id: null,
        qty: 0,
    });
    const [rowDetails, setRowDetails] = useState([]);
    const [keyword, setKeyword] = useState(null);
    const [orderDate, setOrderDate] = useState(null);
    const [dataStock, setStockData] = useState([]);
    const [model, setModel] = useState(null);
    const [dataDetail, setDataDetail] = useState([]);
    const [totalHead, setTotalHead] = useState(0);
    const [totalDetail, setTotalDetail] = useState(0);
    const [descInput, setDescInput] = useState([]);
    const [modalDetail, setmodalDetail] = useState(false);
    const [afterItemInput, setafterItemInput] = useState(null);
    const [pageDetail, setPageDetail] = useState(1);
    const [perPageDetail, setPerPageDetail] = useState(10);
    const [refDNInput, setrefDNInput] = useState(null);
    const [refDNInputID, setrefDNInputID] = useState(null);
    const [modalFailed, setFailedModal] = useState(false);
    const [submitTime, setsubmitTime] = useState(null);
    const [loadingTemplate, setLoadingTemplate] = useState(false);
    const [buttonAccess, setButtonAccess] = useState(null);
    const [generate, setGenerate] = useState([]);
    const [sortDetail, setSortDetail] = useState({
        sort: "updated_at",
        order: "descend",
      });
    const permissions =
        sessionStorage.getItem("permissions") &&
        JSON.parse(sessionStorage.getItem("permissions"));

    useEffect(() => {
    
        const pathname = window.location.pathname.split('/');
        const currentUrl = pathname[1];
        const permissions = sessionStorage.getItem('permissions') && JSON.parse(sessionStorage.getItem('permissions'));
    
        if (permissions) {
          const findPermission = permissions.find((permission) => permission.url === currentUrl);
          const findChildPermission = permissions
            .map((child) => {
              return child.children.find((grandChild) => grandChild.url === currentUrl);
            })
            .filter((grandChild) => grandChild)[0];
    
          if (findChildPermission && findChildPermission.children) {
            const findButtonAccessChildren = findChildPermission.children.filter((x) => x !== null).filter((x) => x.permission_type === 'button');
            if (findButtonAccessChildren) {
              setButtonAccess(findButtonAccessChildren.filter((x) => x !== null));
            }
          }
    
          if (findPermission && findPermission.children) {
            const findButtonAccess = findPermission.children.filter((x) => x.permission_type === 'button');
            if (findButtonAccess) {
              setButtonAccess(findButtonAccess);
            }
          }
        }
    
        // const handleResize = () => {
        //   setIsMobile(window.innerWidth < 768);
        // };
        // handleResize();
        // window.addEventListener('resize', handleResize);
    
        // return () => window.removeEventListener('resize', handleResize);
      }, []);
    useEffect(() => {
        const pathname = window.location.pathname.split("/");
        const currentUrl = pathname[1];
        if (permissions) {
            const findPermission = permissions.find(
                (permission) => permission.url === currentUrl
            );
    
            const findChildPermission = permissions
                .map((child) => {
                    return child.children.find(
                        (grandChild) => grandChild.url === currentUrl
                    );
                })
                .filter((grandChild) => grandChild)[0];
    
            if (findChildPermission && findChildPermission.children) {
                if (findChildPermission.children) {
                    const findButtonAccessChildren = findChildPermission.children
                        .filter((x) => x !== null)
                        .filter((x) => x.permission_type === "button");
                    if (findButtonAccessChildren) {
                        setButtonAccess(findButtonAccessChildren.filter((x) => x !== null));
                    }
                }
            }
    
            if (findPermission && findPermission.children) {
                const findButtonAccess = findPermission.children.filter(
                    (x) => x.permission_type === "button"
                );
                if (findButtonAccess) {
                    setButtonAccess(findButtonAccess);
                }
            }
        }
    },[])
     useEffect(() => {
       var today = moment().format("YYYY-MM"); 
       
        getSelectedModel()
        // getSelectedSupplier()
      },[])
    useEffect(() => {
        var start = date.length != 0 ? date.start:null;
        var end = date.length != 0 ? date.end:null;
        getStocks(start,end);
    }, [keyword, page, sort,orderDate,model]);
    useEffect(() => {
       var today = moment().format("YYYY-MM"); 
        var start = date.length != 0 ? date.start:today;
        var end = date.length != 0 ? date.end:today;
        getDetails(selectedItemNumber,selectedModel,start,end,stockType);
    }, [pageDetail, sortDetail]);
    
      const handleTableChange = (pagination, filters, sorter) => {
        setPagesize(pagination.pageSize);
        setPage(pagination.current);
        setSort({
          sort: sorter.field,
          order: sorter.order,
        });
      };
      const handleTableDetailChange = (pagination, filters, sorter) => {

        console.log(pagination,sorter,'ADA')
        setPagesizeDetail(pagination.pageSize);
        setPageDetail(pagination.current);
        setSortDetail({
          sort: sorter.field,
          order: sorter.order,
        });
      };
   
       const downloadTemplate = () => {
        setLoadingTemplate(true)
        Axios.get(`${url}/master-stock-internal/template`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
          responseType: "blob",
        }).then((res) => {
            setLoadingTemplate(false)
            fileDownload(res.data, "Template-Adjust-Stock" + ".xlsx");
          });
        };
      
    
    const getStocks = (start=null,end=null) => {
        setloading(true);
        Axios.get(`${url}/master-stock-internal/get-data`, {
          params: {
           keyword:keyword,
           columns: [
            "item_number",
            "used_to_code",
            "tanggal",
            "keterangan",
          ],
          perpage:pageSize,
          page:page,
          start:start,
          end:end,
          sort:sort.sort,
          order:sort.order,
          model:model != null ? model.value:null,
          filter_date:orderDate,
          },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }).then((res) => {
          setStockData(res.data.data);
          setTotalHead(res.data.total);
          setloading(false);
        }) .catch((err) => {
            setloading(false);

          if (err.response) {
            setData({
              ...data,
              kanban_number: "",
            });
            Modal.error({
              title: "Failed!",
              content: err.response.data.message,
            });
            
            if (err.response.status == 401) {
              sessionStorage.removeItem("token");
            }
          }
        });
      };
    const detailModal = (item_number,model,type) => {
      // console.log('opened')
        var today = moment().format("YYYY-MM"); 
        var start = date.length != 0 ? date.start:today;
        var end = date.length != 0 ? date.end:today;
        setmodalDetail(true)
        setSelectedItemNumber(item_number)
        setSelectedModel(model)
        setStockType(type)
        getDetails(item_number,model,start,end,type)

    }
    const getDetails = (item_number,model,start=null,end=null,type=null) => {
        if(type != null || type != undefined){
          setLoadingDetail(true);
          Axios.get(`${url}/master-stock-internal/get-details`, {
            params: {
            item_number:item_number,
            model:model,
            keyword:keyword,
            columns: [
              "item_number",
              "used_to_code",
              "tanggal",
              "keterangan",
            ],
            perpage:pageSizeDetail,
            page:pageDetail,
            start:start,
            end:end,
            type:type == null ? stockType:type,
            model:model,
            sort:sortDetail.sort,
            order:sortDetail.order,
            },
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }).then((res) => {
            setRowDetails(res.data.data);
            setTotalDetail(res.data.total);
            setLoadingDetail(false);
          }) .catch((err) => {
            
            setLoadingDetail(false);
            if (err.response) {
              setData({
                ...data,
                kanban_number: "",
              });
              Modal.error({
                title: "Failed!",
                content: err.response.data.message,
              });
              
              if (err.response.status == 401) {
                sessionStorage.removeItem("token");
              }
            }
          });
        } else {
          return false;
        }
        

    }
    const closeModal = () => {
        setFailedModal(false);
        setmodalDetail(false);
        setModalImport(false);
        setRowDetails([]);
    };
    
      const handleDatepicker = (value) => {
        if (value != null) {
          var date = moment(value).format("YYYY-MM-DD");
          
          setOrderDate(date);
        }
      };
      const handleSearch = (value) => {
        if (value != null) {
        
        
          setKeyword(value);
        }
      };
     
    const ExportStock = () => {
        setloading(true);
        Axios.post(
          `${url}/master-stock-internal/export`,
          {
            keyword:keyword,
            columns: [
              "item_number",
              "used_to_code",
              "tanggal",
              "keterangan",
            ],
            perpage:pageSize,
            page:page,
            start:date.start,
            end:date.end,
            filter_date:orderDate,
            model:model,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
            responseType: 'blob',
          }
        )
          .then((res) => {
            var nmdate = date == null ? moment().format("YYYY-MM"):moment(date.start).format("YYYY-MM")
            const filename = `Stock Internal - ${nmdate}.xlsx`;
            console.log('Date :', orderDate);
            fileDownload(res.data, filename);
            setloading(false);
                 
           
          })
          .catch((err) => {
            // console.log(err.response.data);
                if (err.response) {
                 
                  Modal.error({
                    title: "Failed!",
                    content: err.response.data.message,
                  });
                  // message.error(err.response.data.message);
                  if (err.response.status === 422) {
                    setError(err.response.data.errors);
                  }
                  if (err.response.status === 401) {
                    sessionStorage.removeItem("token");
                  }
                }
                setloading(false);
          }
          );
    };
    const handleChangeModel = (value) =>
    {
      setModel(value)
    }
      const getSelectedModel = (models) => {

          let fd = new FormData();
          // fd.set("keyword", models);
          Axios.post(`${url}/master-model/list`, fd, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          })
          .then((res) => {
            // console.log(res)
            var jsons = res.data.data;
            setSelectProject(jsons);
            
            })
            .catch((err) => {
              if (err.response) {
                message.error(err.response.data.message);
              
                if (err.response.status == 401) {
                  sessionStorage.removeItem("token");
                }
              }
              // setLoading(false);
            });
        };

    const columnDetails = [
  
       
        {
            title: "Tipe",
            dataIndex: "type",
            sorter: true,
        },
        {
            title: "Tanggal",
            dataIndex: "tanggal",
            sorter: true,
        },
        {
            title: "Std Pack",
            dataIndex: "std_pack",
            sorter: true,
        },
        {
            title: "Qty Kanban",
            dataIndex: "qty_kanban",
            sorter: true,
        },
        {
            title: "Kode",
            dataIndex: "used_to_code",
            sorter: true,
        },
        {
            title: "Storage",
            dataIndex: "storage",
            sorter: true,
        },
        {
            title: "Keterangan",
            dataIndex: "keterangan",
            sorter: true,
        }
      ]
    const columns = [
  
       
        {
            title: "Item Number",
            dataIndex: "item_number",
            sorter: true,
        },
       
        {
            title: "Model",
            dataIndex: "model",
            sorter: true,
        },
        //   {
        //     title: "Storage",
        //     dataIndex: "storage",
        //     sorter: false,
        // },
        {
            title: "Std Pack",
            dataIndex: "std_pack",
            sorter: true,
            // render: (index, record) => {
            //     return record.supplier_name+" (" + record.supplier_code + ") ";
            // }
        },
      
        {
            title: "Total Qty In",
            dataIndex: "stock_in",
            sorter: true,
        },
        {
            title: "Total Qty Out",
            dataIndex: "stock_out",
            sorter: true,
        },
        {
            title: "Current Stock",
            dataIndex: "current_stock",
            sorter: true,
             render: (index, record) => {
             
                return (<>
                
                  
                <a href="#"
                onClick={(e) => {detailModal(record.item_number,record.model,'current-stock')}}
                        // loading={loading}
                        >
                       {record.current_stock}
                    </a>
             
                </>)
            }
            
        },
        
        {
            title: "Total Adjust",
            dataIndex: "adjusted",
            sorter: true,
             render: (index, record) => {
              
                return (<>
                
                  
                <a href="#"
                onClick={(e) => {detailModal(record.item_number,record.model,'adjust-stock')}}
                        // loading={loading}
                        >
                      {record.adjusted}
                    </a>
             
                </>)
            }
        },
         {
            title: "Actual  Stock",
            dataIndex: "actual_stock",
            sorter: true,
             render: (index, record) => {
              
                return (<>
                
                  
                {/* <a href="#"
                onClick={(e) => {detailModal(record.item_number,record.model,'actual-stock')}}
                        // loading={loading}
                        > */}
                       {record.actual_stock}
                    {/* </a> */}
             
                </>)
            }
        },
        
         {
          title: "Last Update",
          dataIndex: "created_at",
          sorter: true,
        },
      
      
        // {
        //     title: "Action",
        //     dataIndex: "action",
        //     sorter: false,
            
        //     render: (index, record) => {
        //         return (<>
                
                  
        //         <Button
        //         onClick={(e) => {detailModal(record.item_number,record.model)}}
        //                 // loading={loading}
        //                 type="primary"
        //             >
        //                 <EyeFilled />
        //                Detail
        //             </Button>
        //         {/* <Button
        //                 // loading={loading}
          
        //                 color="#ffc53d"
        //             >
        //                 <EditOutlined />
        //                Adjust
        //             </Button> */}
        //         </>)
        //     }
        // },
       
       
    ];
     const handleBeforeUpload = (files) => {
      setData({
        ...data,
        file: files,
      });

      return false;
    };
    const handleRemove = () => {
    setData({
      ...data,
      file: null,
    });
  };

   const onSaveData = () => {
    setloading(true);

    let fd = new FormData();

    fd.append("file", data.file);

    Axios.post(`${url}/master-stock-internal/adjust-import`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        // // console.log('a',res.data.data );
        if(res.data.total_failed > 0)
        {
          message.warning(res.data.message);
          setFailedData(res.data.failed)
          setFailedModal(1)
        } else{
          getStocks(date.start,date.start)
          message.success(res.data.message);
          closeModal();
        }
     
      })
      .catch((err) => {
        if (err.response) {
          const errorsKey = Object.keys(err.response.data.errors);
          const errors = err.response.data.errors;

          message.open({
            message: `Error!: ${err.response.data.message}`,
            description: (
              <div>
                Error Details:
                {errorsKey.map((error) => {
                  return <div>{errors[error][0]}</div>;
                })}
              </div>
            ),
          });

          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        } else {
          message.error("Backend not yet Started");
        }
        setloading(false);
      })
      .finally(() => {
        // setloading(false);
      });
  };

   const columnsFailed = [
  
    {
      title: "Item Number",
      dataIndex: "id_qad",
      // defaultSortOrder: "ascend",
      // render: (text) => {
      //   return <Link to={`${pathname}/details/${text}`}>{text}</Link>;
      // },
    },
    
    {
      title: "Model",
      dataIndex: "model",
      key: "model",
      // defaultSortOrder: "ascend",
      // render: (text) => {
      //   return <Link to={`${pathname}/details/${text}`}>{text}</Link>;
      // },
    },
    {
      title: "Pesan",
      dataIndex: "reason",
      // defaultSortOrder: "ascend",
      // render: (text) => {
      //   return <Link to={`${pathname}/details/${text}`}>{text}</Link>;
      // },
    },
   
  ];

    return (
        <Fragment>
        <Modal
                title="Detail Error"
                visible={modalFailed}
                width={1200}
                footer={null}
                onCancel={closeModal}
              >
                <Card className="body-data">
                  <div name="control-hooks">
                    <Table
                    
                      columns={columnsFailed}
                      dataSource={failedData}
                      rowKey={(data) => data._id}
                      onChange={handleTableChange}
                      loading={loading}
                    />
                    <div>
                      <Button onClick={closeModal}>
                        Tutup
                      </Button>
                    </div>
                  </div>
                </Card>
              </Modal>
          <Modal
        title="Import Adjust Stock"
        visible={modalImport}
        footer={null}
        onCancel={closeModal}
      >
        <Card className="body-data">
          <div name="control-hooks">
            <div name="file" label="File">
              <Fragment>
                <Upload
                  onRemove={handleRemove}
                  beforeUpload={handleBeforeUpload}
                  fileList={[]}
                >
                  <Button style={{ marginBottom: 10 }}>
                    Pilih File <ExportOutlined />
                  </Button>
                </Upload>
                {data.file && (
                  <React.Fragment
                    children={[
                      <Button onClick={handleRemove} type="danger" ghost>
                        <DeleteOutlined />
                      </Button>,
                    ]}
                  >
                    {data.file.name ? data.file.name : data.file}
                  </React.Fragment>
                )}
              </Fragment>
            </div>
            <div>
              <Button
                loading={loading}
                onClick={onSaveData}
                type="primary"
                htmlType="submit"
                className="mr-button"
                style={{
                  marginRight: 10,
                }}
              >
                Unggah
              </Button>
              <Button htmlType="reset" onClick={handleRemove}>
                Batal
              </Button>
            </div>
          </div>
        </Card>
      </Modal>
      
            <Modal
                  title={"Detail Stock "+selectedItemNumber+" ("+selectedModel+")"}
                  footer={null}
                  closable={{ 'aria-label': ' Close Button' }}
                  visible={modalDetail}
                  onCancel={closeModal}
                   width={1200}
                >
                  {/* <DatePicker
                     defaultValue={
                                          date == null ? moment():moment(date.start)
                                          }
                    // pick={console.log(date.start,date.end, moment(date.start, "YYYY-MM"),'START')}
                     picker="month"
                    allowClear={false}
                    format={"YYYY-MM"}
                    inputReadOnly={true}
                    onChange={(value) => {
                      setDate({
                        ...date,
                        start: moment(value).format("YYYY-MM"),
                        end: moment(value).format("YYYY-MM"),
                      })
                       getDetails(selectedItemNumber,selectedModel,moment(value).format("YYYY-MM"),moment(value).format("YYYY-MM"),stockType)
                    }
                    }
                    style={{
                      marginRight: 10,
                    }}
                    ranges={{
                      Today: [moment(), moment()],
                      "This Month": [
                        moment().startOf("month"),
                        moment().endOf("month"),
                      ],
                    }}
                  />  */}
                  {/* <Select
                  mode="multiple"
                  placeholder="Code Stock"
                  defaultValue={[]}
                  // onChange={handleChange}
                  style={{ width: '100%' }}
                  // options={['KANBAN-GENERATE', 'PRODUCTION-REQUEST-STOCK','MATERIAL-ORDER', 'MANUAL-ORDER-MATERIAL-ORDER','NON-PO-MATERIAL-ORDER', 'PRODUCTION-STOCK','PRINT-FG','PRINT-WIP','MATCHING','RECEIVE-DO','TRANSFORMASI-BEFORE']}
                /> */}
                  <Table
                      scroll={{ x: 1400 }}
                      columns={columnDetails}
                      
                      size="small"
                      dataSource={rowDetails}
                      rowKey={(data) => data._id}
                      onChange={handleTableDetailChange}
                      pagination={{
                          pageSize: pageSizeDetail,
                          total: totalDetail,
                          showSizeChanger: true,
                      }}
                      loading={loadingDetail}
                      />
                </Modal>
            <Row>
                <Col xs={24}>
                    <Card
                        type="inner"
                        title="Master Stock"
                        bodyStyle={{ padding: "0" }}
                        extra={moment(new Date()).format("DD MMMM YYYY")}
                    ></Card>
                </Col>
            </Row>
            <Content className="content">
                <Row>
                    <Col xs={24}>
                        <Card className="body-data">
                            <Form {...layout} layout="vertical" >
                                <Row>
                                    <Col  xs={24} md={12} lg={10}>
                                          <Space>
                                             {buttonAccess?.find((x) => x.url === 'master-stock-internal/adjust-stock') && (
                                            <Button
                                                    loading={loading}
                                                    onClick={() =>setModalImport(true)}
                                                    type="primary"
                                                >
                                                    <UploadOutlined />
                                                    Adjust Stock
                                                </Button>)}
                                               {buttonAccess?.find((x) => x.url === 'master-stock-internal/export') && (
                                                <Button
                                                    loading={loading}
                                                    onClick={ExportStock}
                                                    type="primary"
                                                    
                                                >
                                                    <DownloadOutlined />
                                                    Export
                                                </Button>)}
                                                {buttonAccess?.find((x) => x.url === 'master-stock-internal/adjust-stock') && (
                                                <Button
                                                    loading={loadingTemplate}
                                                    onClick={downloadTemplate}
                                                    type="default"
                                                >
                                                    <FileExcelOutlined />
                                                    Template
                                                </Button>
                                                )}
                                          </Space>
                                                
                                         
                                    </Col>
                                    
                                    <Col xs={24} md={12} lg={14} className="align-right">
                                    <Select
                                              allowClear
                                              labelInValue
                                              placeholder="Model"
                                              onChange={(value) =>
                                                handleChangeModel(value)
                                              }
                                               style={{
                                            width: "170px",
                                          }}
                                              showSearch
                                              onSearch={(value) => getSelectedModel(value)}
                                              filterOption={false}
                                              // value={{
                                              //   key: model.value,
                                              //   label: model.value,
                                              // }}
                                            >
                                              {selectProject &&
                                                selectProject.map((dt) => {
                                                  return (
                                                    <Option value={dt.model} key={dt._id}>
                                                      {dt.label}
                                                    </Option>
                                                  );
                                                })}
                                            </Select>
                                        <DatePicker 
                                          defaultValue={
                                          date == null ? moment():moment(date.start)
                                          }
                                          picker="month"
                                          allowClear={false}
                                          format={"YYYY-MM"}
                                          inputReadOnly={true}
                                          onChange={(value) =>{
                                            setDate({
                                              ...date,
                                              start: moment(value).format("YYYY-MM"),
                                              end: moment(value).format("YYYY-MM"),
                                            })
                                            getStocks(moment(value).format("YYYY-MM"),moment(value).format("YYYY-MM"))
                                          }
                                          }
                                            style={{
                                            width: "150px",
                                          }}
                                          ranges={{
                                            Today: [moment(), moment()],
                                            "This Month": [
                                              moment().startOf("month"),
                                              moment().endOf("month"),
                                            ],
                                          }}
                                        /> 
                                       
                                        <Search
                                           style={{
                                            width: "200px",
                                          }}
                                        placeholder="Search ..."
                                        onSearch={(value) => handleSearch(value)}
                                        />
                                    </Col>
                  </Row>
                  <Divider />
                                <Row>
                                    <Col xs={24} md={24} lg={24}>
                                        <Table
                                            scroll={{ x: 1400 }}
                                            columns={columns}
                                           
                                            size="small"
                                            dataSource={dataStock}
                                            rowKey={(data) => data._id}
                                            onChange={handleTableChange}
                                            pagination={{
                                                pageSize: pageSize,
                                                total: totalHead,
                                                showSizeChanger: true,
                                            }}
                                            loading={loading}
                                            />
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </Content>
        </Fragment>
    );
}

export default MasterStock;
